function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F27557",
  d: "M65.872 39.833a3.061 3.061 0 0 1-3.066 3.061h-45.95a3.066 3.066 0 1 1 0-6.128h45.945a3.065 3.065 0 0 1 3.066 3.067M53.612 56.675H26.046a3.066 3.066 0 1 1 0-6.123h27.571a3.066 3.066 0 0 1 0 6.128m-27.571-33.7h27.571a3.066 3.066 0 0 1 0 6.128H26.046a3.066 3.066 0 1 1 0-6.127m36.859-7.708a33.377 33.377 0 0 0-23.049-9.134c-17.784-.023-32.52 13.79-33.644 31.539A33.446 33.446 0 0 0 15.277 62.9 33.387 33.387 0 0 0 39.83 73.527h33.7V39.833a33.377 33.377 0 0 0-10.626-24.56"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C34027",
  d: "M73.526 73.527h-33.69A33.387 33.387 0 0 1 15.276 62.9a33.446 33.446 0 0 1-9.064-25.223C7.334 19.928 22.07 6.114 39.856 6.138a33.377 33.377 0 0 1 23.049 9.135 33.377 33.377 0 0 1 10.62 24.56v33.694zm-6.43-62.717A39.46 39.46 0 0 0 37.296.09C17.295 1.36 1.357 17.297.088 37.296a39.51 39.51 0 0 0 10.724 29.806 39.975 39.975 0 0 0 29.018 12.552h36.756a3.061 3.061 0 0 0 3.071-3.056V39.833A39.975 39.975 0 0 0 67.096 10.81z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M53.617 50.552H26.046a3.066 3.066 0 0 0 0 6.128h27.571a3.066 3.066 0 0 0 0-6.128zM26.046 29.108h27.571a3.066 3.066 0 0 0 0-6.127H26.046a3.066 3.066 0 1 0 0 6.127zm-9.19 7.663a3.066 3.066 0 0 0 0 6.123h45.95a3.066 3.066 0 0 0 0-6.128h-45.95v.005z"
}));

var SvgQuipIco = function SvgQuipIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuipIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quip_ico.30db3e09.svg";
export { ForwardRef as ReactComponent };